import { render, staticRenderFns } from "./ProductoVenta.vue?vue&type=template&id=078425f0&scoped=true&"
import script from "./ProductoVenta.vue?vue&type=script&lang=js&"
export * from "./ProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078425f0",
  null
  
)

export default component.exports